export default {
	$accessibility: {
		archived: "Archivé",
		present: "Présent",
	},
	$accessModifier: {
		$description: {
			hidden_from_receiver: "Caché du récepteur",
			hidden_from_sender: "Caché de l'expéditeur",
			private: "Privé",
			shared_with_custom: "Partagé avec personnalisé",
			shared_with_everyone: "Partagé avec tout le monde",
			shared_with_receiver: "Partagé avec le récepteur",
			shared_with_sender: "Partagé avec l'expéditeur",
		},
	},
	$antProduct: {
		limitGBStorage: "{limit}Go de stockage",
		limitMBStorage: "{limit}Mo de stockage",
		limitUser: "{limit} Utilisateur",
		limitUsers: "{limit} Utilisateurs",
		renewAtPricePerUnit: "Renouvellement à {currency}{price} par {unit}",
		unlimitedModule: "{module} Illimité",
		upToLimitModule: "Jusqu'à {limit} {module}",
	},
	$company: {
		address: "Kotekli Mah. Denizli Yolu Bul. Teknopark Sitesi B Blok No:4B Ic kapi No:14 MENTESE / MUGLA, TURQUIE",
		googleMapSrc:
			"https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12715.523446137679!2d28.3731307!3d37.1793022!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14bf732687fd3eb1%3A0x2815d6eefcce8910!2sMu%C4%9Fla%20Teknopark!5e0!3m2!1sfr!2str!4v1701805110461!5m2!1sfr!2str",
		name: "Slush Software Inc.",
		phoneNumber: "+90 (555) 444-33-22",
		slogan:
			"Accélérez votre entreprise avec Antrego. Gérez vos processus d'expédition numériquement, en toute sécurité et facilement.",
	},
	$cookieBanner: {
		accept: "Accepter",
		decline: "Refuser",
		message:
			"Nous utilisons des cookies et des technologies similaires pour l'analyse et du contenu personnalisé. En cliquant sur 'Accepter', vous consentez à l'utilisation de ces technologies.",
	},
	$country: {
		afghanistan: "Afghanistan",
		aland: "Åland",
		albania: "Albanie",
		algeria: "Algérie",
		american_samoa: "Samoa américaines",
		andorra: "Andorre",
		angola: "Angola",
		anguilla: "Anguilla",
		antarctica: "Antarctique",
		antigua_and_barbuda: "Antigua-et-Barbuda",
		argentina: "Argentine",
		armenia: "Arménie",
		aruba: "Aruba",
		australia: "Australie",
		austria: "Autriche",
		azerbaijan: "Azerbaïdjan",
		bahamas: "Bahamas",
		bahrain: "Bahreïn",
		bangladesh: "Bangladesh",
		barbados: "Barbade",
		belarus: "Biélorussie",
		belgium: "Belgique",
		belize: "Belize",
		benin: "Bénin",
		bermuda: "Bermudes",
		bhutan: "Bhoutan",
		bolivia: "Bolivie",
		bonaire_sint_eustatius_and_saba: "Bonaire, Saint-Eustache et Saba",
		bosnia_and_herzegovina: "Bosnie-Herzégovine",
		botswana: "Botswana",
		bouvet_island: "Île Bouvet",
		brazil: "Brésil",
		british_indian_ocean_territory: "Territoire britannique de l'océan Indien",
		british_virgin_islands: "Îles Vierges britanniques",
		brunei: "Brunei",
		bulgaria: "Bulgarie",
		burkina_faso: "Burkina Faso",
		burundi: "Burundi",
		cabo_verde: "Cap-Vert",
		cambodia: "Cambodge",
		cameroon: "Cameroun",
		canada: "Canada",
		cayman_islands: "Îles Caïmans",
		central_african_republic: "République Centrafricaine",
		chad: "Tchad",
		chile: "Chili",
		china: "Chine",
		christmas_island: "Île Christmas",
		cocos_islands: "Îles Cocos [Keeling]",
		colombia: "Colombie",
		comoros: "Comores",
		congo_republic: "République du Congo",
		cook_islands: "Îles Cook",
		costa_rica: "Costa Rica",
		croatia: "Croatie",
		cuba: "Cuba",
		curacao: "Curaçao",
		cyprus: "Chypre",
		czechia: "Tchéquie",
		denmark: "Danemark",
		djibouti: "Djibouti",
		dominica: "Dominique",
		dominican_republic: "République Dominicaine",
		dr_congo: "République Démocratique du Congo",
		ecuador: "Équateur",
		egypt: "Égypte",
		el_salvador: "El Salvador",
		equatorial_guinea: "Guinée équatoriale",
		eritrea: "Érythrée",
		estonia: "Estonie",
		eswatini: "Eswatini",
		ethiopia: "Éthiopie",
		falkland_islands: "Îles Falkland",
		faroe_islands: "Îles Féroé",
		fiji: "Fidji",
		finland: "Finlande",
		france: "France",
		french_guiana: "Guyane française",
		french_polynesia: "Polynésie française",
		french_southern_territories: "Terres Australes et Antarctiques Françaises",
		gabon: "Gabon",
		gambia: "Gambie",
		georgia: "Géorgie",
		germany: "Allemagne",
		ghana: "Ghana",
		gibraltar: "Gibraltar",
		greece: "Grèce",
		greenland: "Groenland",
		grenada: "Grenade",
		guadeloupe: "Guadeloupe",
		guam: "Guam",
		guatemala: "Guatemala",
		guernsey: "Guernesey",
		guinea: "Guinée",
		guinea_bissau: "Guinée-Bissau",
		guyana: "Guyana",
		haiti: "Haïti",
		heard_island_and_mcdonald_islands: "Îles Heard-et-MacDonald",
		honduras: "Honduras",
		hong_kong: "Hong Kong",
		hungary: "Hongrie",
		iceland: "Islande",
		india: "Inde",
		indonesia: "Indonésie",
		iran: "Iran",
		iraq: "Irak",
		ireland: "Irlande",
		isle_of_man: "Île de Man",
		israel: "Israël",
		italy: "Italie",
		ivory_coast: "Côte d'Ivoire",
		jamaica: "Jamaïque",
		japan: "Japon",
		jersey: "Jersey",
		jordan: "Jordanie",
		kazakhstan: "Kazakhstan",
		kenya: "Kenya",
		kiribati: "Kiribati",
		kosovo: "Kosovo",
		kuwait: "Koweït",
		kyrgyzstan: "Kirghizistan",
		laos: "Laos",
		latvia: "Lettonie",
		lebanon: "Liban",
		lesotho: "Lesotho",
		liberia: "Libéria",
		libya: "Libye",
		liechtenstein: "Liechtenstein",
		lithuania: "Lituanie",
		luxembourg: "Luxembourg",
		macao: "Macao",
		madagascar: "Madagascar",
		malawi: "Malawi",
		malaysia: "Malaisie",
		maldives: "Maldives",
		mali: "Mali",
		malta: "Malte",
		marshall_islands: "Îles Marshall",
		martinique: "Martinique",
		mauritania: "Mauritanie",
		mauritius: "Île Maurice",
		mayotte: "Mayotte",
		mexico: "Mexique",
		micronesia: "Micronésie",
		moldova: "Moldavie",
		monaco: "Monaco",
		mongolia: "Mongolie",
		montenegro: "Monténégro",
		montserrat: "Montserrat",
		morocco: "Maroc",
		mozambique: "Mozambique",
		myanmar: "Birmanie",
		namibia: "Namibie",
		nauru: "Nauru",
		nepal: "Népal",
		netherlands: "Pays-Bas",
		new_caledonia: "Nouvelle-Calédonie",
		new_zealand: "Nouvelle-Zélande",
		nicaragua: "Nicaragua",
		niger: "Niger",
		nigeria: "Nigeria",
		niue: "Niue",
		norfolk_island: "Île Norfolk",
		north_korea: "Corée du Nord",
		north_macedonia: "Macédoine du Nord",
		northern_mariana_islands: "Îles Mariannes du Nord",
		norway: "Norvège",
		oman: "Oman",
		pakistan: "Pakistan",
		palau: "Palaos",
		palestine: "Palestine",
		panama: "Panama",
		papua_new_guinea: "Papouasie-Nouvelle-Guinée",
		paraguay: "Paraguay",
		peru: "Pérou",
		philippines: "Philippines",
		pitcairn_islands: "Îles Pitcairn",
		poland: "Pologne",
		portugal: "Portugal",
		puerto_rico: "Porto Rico",
		qatar: "Qatar",
		reunion: "La Réunion",
		romania: "Roumanie",
		russia: "Russie",
		rwanda: "Rwanda",
		saint_barthelemy: "Saint-Barthélemy",
		saint_helena: "Sainte-Hélène",
		saint_lucia: "Sainte-Lucie",
		saint_martin: "Saint-Martin",
		saint_pierre_and_miquelon: "Saint-Pierre-et-Miquelon",
		samoa: "Samoa",
		san_marino: "Saint-Marin",
		sao_tome_and_principe: "Sao Tomé-et-Principe",
		saudi_arabia: "Arabie Saoudite",
		senegal: "Sénégal",
		serbia: "Serbie",
		seychelles: "Seychelles",
		sierra_leone: "Sierra Leone",
		singapore: "Singapour",
		sint_maarten: "Saint-Martin",
		slovakia: "Slovaquie",
		slovenia: "Slovénie",
		solomon_islands: "Îles Salomon",
		somalia: "Somalie",
		south_africa: "Afrique du Sud",
		south_georgia_and_south_sandwich_islands: "Géorgie du Sud et Îles Sandwich du Sud",
		south_korea: "Corée du Sud",
		south_sudan: "Soudan du Sud",
		spain: "Espagne",
		sri_lanka: "Sri Lanka",
		st_kitts_and_nevis: "Saint-Kitts-et-Nevis",
		st_vincent_and_grenadines: "Saint-Vincent-et-les-Grenadines",
		sudan: "Soudan",
		suriname: "Suriname",
		svalbard_and_jan_mayen: "Svalbard et Jan Mayen",
		sweden: "Suède",
		switzerland: "Suisse",
		syria: "Syrie",
		taiwan: "Taïwan",
		tajikistan: "Tadjikistan",
		tanzania: "Tanzanie",
		thailand: "Thaïlande",
		timor_leste: "Timor-Leste",
		togo: "Togo",
		tokelau: "Tokelau",
		tonga: "Tonga",
		trinidad_and_tobago: "Trinité-et-Tobago",
		tunisia: "Tunisie",
		turkiye: "Turquie",
		turkmenistan: "Turkménistan",
		turks_and_caicos_islands: "Îles Turques-et-Caïques",
		tuvalu: "Tuvalu",
		uganda: "Ouganda",
		ukraine: "Ukraine",
		united_arab_emirates: "Émirats Arabes Unis",
		united_kingdom: "Royaume-Uni",
		united_states: "États-Unis",
		uruguay: "Uruguay",
		us_minor_outlying_islands: "Îles Mineures Éloignées des États-Unis",
		us_virgin_islands: "Îles Vierges américaines",
		uzbekistan: "Ouzbékistan",
		vanuatu: "Vanuatu",
		vatican_city: "Cité du Vatican",
		venezuela: "Venezuela",
		vietnam: "Viêt Nam",
		wallis_and_futuna: "Wallis-et-Futuna",
		western_sahara: "Sahara occidental",
		yemen: "Yémen",
		zambia: "Zambie",
		zimbabwe: "Zimbabwe",
	},
	$currency: {
		euro: "Euro",
		turkish_lira: "Livre turque",
		us_dollar: "Dollar américain",
	},
	$documentManager: {
		message_1:
			"Pour modifier le modèle, cliquez sur le bouton \"Modifier le modèle\" pour accéder à l'écran d'édition.",
		message_2:
			'Vous pouvez modifier le nombre de lignes dans la liste en augmentant ou en diminuant le "Nombre de lignes".',
		message_3:
			'Les modifications apportées aux champs de contenu apparaîtront instantanément dans la section "Aperçu".',
		message_4: 'Pour générer un PDF, cliquez sur le bouton "Actions du document" pour l\'enregistrer au format PDF.',
		message_5: 'Pour accéder aux documents plus tard, vous pouvez les enregistrer via le bouton "Actions du document".',
		message_6: "Les données saisies dans chaque cellule du tableau seront reflétées exactement dans l'aperçu.",
		message_7: "Le tableau de données peut être modifié comme une feuille Excel ou un tableur électronique.",
	},
	$employeeType: {
		admin: "Administrateur",
		default: "Défaut",
		exporter: "Exportateur",
		importer: "Importateur",
	},
	$format: {
		date: "DD/MM/YYYY",
		date_time: "DD/MM/YYYY HH:mm:ss",
		date_time_without_second: "DD/MM/YYYY HH:mm",
	},
	$home: {
		$noCompany: {
			create_company_subtitle: "Créez votre entreprise ici.",
			create_company_title: "Voulez-vous ajouter votre entreprise ?",
			description:
				"Vous vous êtes connecté avec succès. Vous devez maintenant rejoindre une entreprise ou en créer une nouvelle.",
			join_company_subtitle: "Entrez votre code et rejoignez l'entreprise ici.",
			join_company_title: "Voulez-vous rejoindre une entreprise existante ?",
			title: "Bienvenue {name}",
		},
		$unauthorized: {
			description: "Gardez vos processus d'exportation-importation sous contrôle en utilisant Antrego",
			forget_password_subtitle: "Veuillez saisir votre email pour réinitialiser votre mot de passe.",
			sign_in_subtitle: "Connectez-vous ici",
			sign_in_title: "Vous avez déjà un compte ?",
			sign_up_subtitle: "Inscrivez-vous ici",
			sign_up_title: "Voulez-vous créer un compte ?",
			title: "Bienvenue chez Antrego",
		},
	},
	$invitationType: {
		company_partner: "Invitation de coopération commerciale",
		customs_partner: "Invitation de partenaire douanier",
		employee: "Invitation d'employé",
	},
	$landing: {
		$benefits: {
			$detailPage: {
				hero_title: "Transformez vos opérations",
				hero_subtitle: "Avantages de la plateforme",
				hero_description:
					"Découvrez comment Antrego rationalise l’ensemble de votre flux logistique, de la gestion des stocks au suivi des expéditions. Gagnez en efficacité, réduisez les coûts et améliorez la collaboration dans toute votre organisation.",
				features_title: "Avantages complets de la plateforme",
				feature_1_title: "Tableau de bord centralisé",
				feature_1_desc:
					"Accédez à toutes vos données logistiques, expéditions, stocks et documents depuis une interface unique et intuitive.",
				feature_2_title: "Exactitude des données renforcée",
				feature_2_desc:
					"Réduisez les erreurs grâce à la saisie automatisée, la validation et la synchronisation en temps réel entre tous les modules.",
				feature_3_title: "Gain de temps",
				feature_3_desc:
					"Économisez des heures chaque jour grâce aux workflows automatisés, aux notifications intelligentes et aux processus rationalisés.",
				feature_4_title: "Collaboration d’équipe",
				feature_4_desc:
					"Favorisez une collaboration fluide entre équipes internes, clients, fournisseurs et partenaires logistiques.",
				feature_5_title: "Réduction des coûts",
				feature_5_desc:
					"Diminuez les coûts opérationnels grâce à une meilleure efficacité, moins d’erreurs et une allocation optimisée des ressources.",
				feature_6_title: "Évolutivité",
				feature_6_desc:
					"Développez votre activité en toute confiance avec une plateforme qui s’adapte sans effort à vos besoins.",
				benefits_title: "Pourquoi choisir Antrego ?",
				benefit_1: "Visibilité complète sur l’ensemble de votre chaîne d’approvisionnement",
				benefit_2: "Plateforme cloud sécurisée avec chiffrement de niveau entreprise",
				benefit_3: "Design responsive pour un accès en mobilité",
				benefit_4: "Notifications automatisées pour tenir tous les acteurs informés",
				benefit_5: "Workflows personnalisables qui s’adaptent à vos processus",
				benefit_6: "Équipe d’assistance dédiée pour garantir votre réussite",
				workflow_title: "Comment Antrego transforme vos opérations",
				step_1_title: "Consolidez vos opérations",
				step_1_desc:
					"Regroupez la gestion des stocks, le suivi des expéditions, la gestion documentaire et la communication client dans une plateforme intégrée.",
				step_2_title: "Automatisez les tâches récurrentes",
				step_2_desc:
					"Laissez Antrego gérer les tâches répétitives comme la saisie de données, les notifications et les mises à jour de statut, afin de libérer votre équipe pour des missions stratégiques.",
				step_3_title: "Activez la collaboration en temps réel",
				step_3_desc:
					"Partagez instantanément les informations avec tous les intervenants pour que chacun dispose des dernières mises à jour et documents.",
				step_4_title: "Prenez des décisions fondées sur les données",
				step_4_desc:
					"Exploitez des analyses et des rapports complets pour identifier les tendances, optimiser les processus et favoriser l’amélioration continue.",
				cta_title: "Prêt à transformer vos opérations logistiques ?",
				cta_button: "Commencez gratuitement dès aujourd’hui",
				cta_subtitle: "Aucune carte bancaire requise • Rejoignez plus de 500 entreprises",
			},
			benefits_title: "Avantages de la plateforme",
			business_process: "Accélère vos processus d'affaires.",
			control_title: "Prenez le contrôle avec Antrego.",
			highlight_word: "contrôle",
			risk_of_error: "Réduit les risques d'erreurs.",
			text: "Antrego transforme les opérations logistiques des exportateurs, importateurs, transitaires et fabricants grâce à des solutions numériques de bout en bout pour la gestion des stocks, le suivi des expéditions en temps réel et l’automatisation de la documentation.",
			time_and_cost_savings: "Économise du temps et des coûts.",
		},
		$content: {
			$text: {
				0: "Suivez toutes vos expéditions en un seul endroit et contrôlez vos finances grâce à des rapports dynamiques.",
				1: "Partagez vos mises à jour en temps réel avec vos clients pour améliorer la qualité de votre service.",
				2: "Affichez et partagez tous les documents liés à votre expédition dans un seul système.",
				3: "Contrôlez facilement votre processus en accédant à Antrego depuis tous les appareils et lieux.",
				4: "Stockez toutes vos données à l'aide de la technologie de cryptage SHA-256. Soyez assuré quant à la sécurité.",
				5: "Participez à un suivi conjoint avec tous les intervenants dans le processus métier. Gérez le processus plus efficacement.",
			},
			$title: {
				0: "Gestion de bout en bout des expéditions",
				1: "Communication client en temps réel",
				2: "Gestion centralisée des documents",
				3: "Accès cloud partout",
				4: "Sécurité de niveau entreprise",
				5: "Collaboration multipartite",
			},
			content_title: "Tout ce dont vous avez besoin sur une seule plateforme",
		},
		$home: {
			subtitle: "Gérez stocks, expéditions, documents et suivi dans une plateforme puissante",
			text: "Économisez 40 % de temps opérationnel grâce aux workflows automatisés. Rejoignez plus de 500 entreprises qui optimisent leurs opérations logistiques à l’échelle mondiale.",
			title: "Plateforme logistique complète : des stocks à la livraison",
		},
		$lifecycle: {
			headline: "Processus",
			info_button: "Obtenir des informations",
			lifecycle_texts: {
				0: "Téléchargez des fichiers supplémentaires pour créer votre facture proforma et partagez-la instantanément avec votre client.",
				1: "Saisissez les détails de votre expédition et ajoutez des documents. Informez votre client et gérez conjointement tous les processus d'expédition via un seul canal.",
				2: "Suivez votre situation financière liée à l'importation et à l'exportation en temps réel.",
			},
			lifecycle_titles: {
				0: "Connectez-vous et créez une facture proforma",
				1: "Créer une expédition",
				2: "Suivre les activités financières",
			},
			productivity_title: "Augmentez la productivité et réduisez la complexité et les erreurs en 3 étapes.",
			tracking_guide_title: "Guide de suivi facile",
		},
		$logistics: {
			logistics_title: "Types de logistique supportés",
			solutions_title: "La solution adaptée à chaque charge",
			text: "Avec Antrego, votre partenaire numérique dans tous types de transport, nous sommes à vos côtés pour tous vos mouvements mondiaux.",
		},
		$pdfEditor: {
			$detailPage: {
				hero_title: "Création professionnelle de documents PDF",
				hero_subtitle: "Créez des documents commerciaux superbes en quelques minutes",
				hero_description:
					"L’éditeur PDF intuitif d’Antrego vous permet de concevoir, personnaliser et générer facilement des factures, proformas et documents commerciaux professionnels. Aucune compétence en design requise.",
				features_title: "Tout pour créer des documents professionnels",
				feature_1_title: "Éditeur par glisser-déposer",
				feature_1_desc:
					"Une interface intuitive pour ajouter textes, images, logos et tableaux par simples actions de glisser-déposer. Aucune compétence technique nécessaire.",
				feature_2_title: "Modèles personnalisés",
				feature_2_desc:
					"Choisissez parmi des modèles prédéfinis ou créez vos propres mises en page. Enregistrez vos modèles pour une image de marque cohérente.",
				feature_3_title: "Champs de formulaire intelligents",
				feature_3_desc:
					"Renseignez automatiquement les informations clients, les détails produits et les prix. Connectez-vous directement à vos données d’expédition et de stock.",
				feature_4_title: "Personnalisation de la marque",
				feature_4_desc:
					"Ajoutez votre logo, choisissez vos couleurs et polices pour créer des documents parfaitement alignés sur l’identité de votre entreprise.",
				feature_5_title: "Export multi-format",
				feature_5_desc:
					"Téléchargez en PDF, imprimez directement ou partagez par e-mail. Tous les documents sont mis en forme de manière professionnelle et prêts à l’impression.",
				feature_6_title: "Gestion des versions",
				feature_6_desc:
					"Suivez les révisions, conservez l’historique et accédez aux versions précédentes. Ne perdez plus jamais une itération importante.",
				benefits_title: "Pourquoi choisir le créateur PDF d’Antrego ?",
				benefit_1: "Créez des documents professionnels 10× plus vite que les méthodes traditionnelles",
				benefit_2: "Maintenez une image de marque cohérente sur tous vos documents commerciaux",
				benefit_3: "Réduisez les erreurs grâce au remplissage automatique depuis vos expéditions",
				benefit_4: "Gagnez du temps avec des modèles réutilisables et des formulaires intelligents",
				benefit_5: "Impressionnez vos clients avec des documents soignés et professionnels",
				benefit_6: "Accédez à vos documents partout, à tout moment et depuis n’importe quel appareil",
				workflow_title: "Comment se déroule la création PDF",
				step_1_title: "Choisissez un modèle",
				step_1_desc:
					"Sélectionnez un modèle prédéfini ou partez d’une page blanche pour créer votre mise en page personnalisée.",
				step_2_title: "Personnalisez le contenu",
				step_2_desc:
					"Glissez-déposez des éléments, ajoutez votre logo et votre charte, et remplissez automatiquement les champs avec les données d’expédition.",
				step_3_title: "Aperçu et édition",
				step_3_desc:
					"Prévisualisez votre document en temps réel, ajustez-le et assurez-vous que tout est parfait avant la génération.",
				step_4_title: "Générez et partagez",
				step_4_desc:
					"Téléchargez en PDF, envoyez directement par e-mail aux clients ou joignez aux expéditions. Enregistrez le modèle pour un usage futur.",
				cta_title: "Commencez à créer des documents professionnels dès aujourd’hui",
				cta_button: "Commencer gratuitement",
				cta_subtitle: "Aucune carte bancaire requise • Démarrez en quelques minutes",
			},
			description:
				"Notre éditeur PDF est un outil puissant qui rend la création et la modification de factures plus pratiques. Gagnez du temps et présentez des documents d'aspect professionnel à vos partenaires commerciaux.",
			features: {
				design:
					"Conception de factures : ajoutez votre logo, ajustez les couleurs et personnalisez le format de votre facture.",
				edit: "Édition de documents : modifiez rapidement des PDF, ajoutez ou supprimez du texte.",
				shareSave:
					"Partage et enregistrement : téléchargez, partagez ou stockez vos documents créés directement sur la plateforme.",
			},
			longTitle: "Des factures rapides et personnalisées avec l'éditeur PDF.",
			note: "Cette configuration permet aux utilisateurs d'explorer visuellement les fonctionnalités et de passer en revue les avantages par écrit.",
			title: "Créer des factures est si facile !",
		},
		$process: {
			comparison_subtitle: "Voyez la différence entre la gestion logistique traditionnelle et numérique",
			digital_future: "Abandonnez les méthodes traditionnelles et entrez dans l'avenir numérique",
			digital_shipping: "Suivi numérique des expéditions avec Antrego",
			digital_shipping_texts: {
				0: "Les factures proforma pour les commandes entrantes sont créées et suivies facilement via un seul canal.",
				1: "Les factures proforma sont envoyées, les notifications sont instantanément envoyées au client, et elles sont approuvées via Antrego.",
				2: "Les processus documentaires sont gérés via Antrego. Ils ne sont pas perdus, aucun retard ne se produit, et le potentiel d'erreurs est minimisé.",
				3: "Les fournisseurs, clients et courtiers en douane peuvent instantanément voir les détails de l'expédition et les suivre conjointement.",
				4: "Les rapports financiers sont générés automatiquement mensuellement et annuellement.",
			},
			question_title: "Comment Antrego vous fait gagner plus de 10 heures par semaine",
			tracking_method: "Numérisez vos méthodes de suivi et accélérez vos processus.",
			traditional_shipping: "Suivi traditionnel des expéditions",
			traditional_shipping_texts: {
				0: "Les commandes sont collectées par e-mail, messages ou téléphone via différents canaux, provoquant des difficultés de suivi interne.",
				1: "La facture proforma est créée à l'aide d'outils comme Excel, et le processus d'approbation est géré manuellement par e-mail, WhatsApp ou téléphone.",
				2: "Les processus manuels de documents entraînent des erreurs et des retards, entraînant des pertes de temps et financières.",
				3: "Il n'y a pas de plateforme commune pour que les fournisseurs, clients et courtiers en douane puissent suivre les détails de l'expédition.",
				4: "Les données financières sont vérifiées individuellement après chaque expédition, rendant le reporting difficile.",
			},
		},
		$question: {
			$text: {
				0: "<p>Antrego est une plateforme complète de gestion logistique qui aide les entreprises à suivre leurs expéditions, gérer leurs stocks et collaborer avec leurs clients en temps réel. Elle numérise l’ensemble de votre chaîne d’approvisionnement, des stocks à la livraison.</p>",
				1: "<p>Antrego simplifie la logistique avec un accès facile depuis n’importe quel appareil, une sécurité des données de niveau entreprise utilisant le chiffrement SHA-256 et un suivi partagé qui tient tous les intervenants informés tout au long du processus d’expédition.</p>",
				2: "<p>Antrego prend en charge tous les principaux modes de transport, notamment le fret maritime, le fret aérien, le transport routier et la logistique ferroviaire. Nous travaillons avec tous les grands transporteurs et compagnies maritimes dans le monde.</p>",
				3: "<p>Antrego propose une formule gratuite jusqu’à 10 expéditions par mois sans carte bancaire. Les offres Premium débutent à 99 $/mois pour des expéditions illimitées, avec 16 % d’économie en facturation annuelle. Consultez notre page tarifs pour tous les détails.</p>",
				4: "<p>Nous développons actuellement un accès API et des capacités d’intégration avec les systèmes logistiques et ERP populaires. Ces fonctionnalités d’intégration sont prévues dans de futures versions. Contactez-nous pour en savoir plus sur notre feuille de route et les fonctionnalités à venir.</p>",
				5: "<p>La plupart des entreprises sont opérationnelles en moins de 24 heures. La configuration de base prend seulement 5 à 10 minutes pour créer votre compte et ajouter les informations de l’entreprise. Notre équipe d’onboarding vous aide à importer les données et à personnaliser les workflows.</p>",
			},
			$title: {
				0: "Qu’est-ce qu’Antrego ?",
				1: "Pourquoi utiliser Antrego ?",
				2: "Quels types de logistique Antrego prend-il en charge ?",
				3: "Combien coûte Antrego ?",
				4: "Puis-je intégrer Antrego à mes systèmes existants ?",
				5: "Combien de temps faut-il pour configurer Antrego ?",
			},
			save_percentage: "Économisez 16 % par mois",
			text: "Accédez facilement à toutes les informations avec Antrego, et n'hésitez pas à nous contacter pour toute autre question que vous pourriez avoir.",
			title: "Apprenez rapidement tout ce qui vous intéresse",
		},
		$stockFeature: {
			$detailPage: {
				hero_title: "Transformez votre gestion des stocks",
				hero_subtitle: "De l’inventaire à la vente : gérez tout le cycle de vie produit en numérique",
				hero_description:
					"La fonctionnalité de gestion des stocks d’Antrego permet aux exportateurs et fabricants de gérer efficacement l’inventaire, de partager des catalogues produits avec les clients et d’accélérer le processus de vente via une plateforme intégrée.",
				features_title: "Fonctionnalités puissantes de gestion des stocks",
				feature_1_title: "Gestion d’inventaire centralisée",
				feature_1_desc:
					"Gérez tous vos articles depuis un tableau de bord unique. Suivez les quantités, numéros de lot, entrepôts et détails produits en toute simplicité.",
				feature_2_title: "Catalogue de stock public",
				feature_2_desc:
					"Créez une page de catalogue public pour présenter vos produits disponibles aux clients du monde entier. Partagez votre inventaire via un simple lien.",
				feature_3_title: "Traçabilité par lot",
				feature_3_desc:
					"Suivez chaque lot avec des informations détaillées, y compris quantités, dimensions et attributs personnalisés pour une gestion précise.",
				feature_4_title: "Support multi-entrepôts",
				feature_4_desc:
					"Organisez votre inventaire sur plusieurs entrepôts et sites. Sachez où chaque produit est stocké pour une logistique efficace.",
				feature_5_title: "Galerie d’images produit",
				feature_5_desc:
					"Téléchargez plusieurs images pour chaque article afin d’apporter une clarté visuelle à vos clients et vos équipes.",
				feature_6_title: "Conversion directe en expédition",
				feature_6_desc:
					"Convertissez vos articles de stock en expéditions en toute fluidité. Créez des proformas et des documents d’expédition directement depuis l’inventaire.",
				benefits_title: "Pourquoi choisir Antrego pour la gestion des stocks ?",
				benefit_1: "Augmentez la visibilité de vos produits auprès d’acheteurs du monde entier",
				benefit_2: "Réduisez le temps consacré au suivi manuel des stocks",
				benefit_3: "Rationalisez le passage du stock à la vente",
				benefit_4: "Fournissez des informations de stock en temps réel aux clients",
				benefit_5: "Prise en charge de plus de 15 langues pour toucher des marchés internationaux",
				benefit_6: "Intégration avec les systèmes d’expédition et de facturation",
				workflow_title: "Comment ça marche",
				step_1_title: "Ajoutez vos produits",
				step_1_desc:
					"Créez des articles de stock avec des informations détaillées : caractéristiques produit, quantités, entrepôts et images.",
				step_2_title: "Partagez votre catalogue",
				step_2_desc:
					"Générez un lien public vers votre catalogue de stock que les clients potentiels peuvent consulter à tout moment.",
				step_3_title: "Recevez des demandes",
				step_3_desc:
					"Les clients consultent vos produits disponibles et vous contactent directement pour des commandes et devis.",
				step_4_title: "Convertissez en ventes",
				step_4_desc:
					"Créez facilement des proformas et des expéditions à partir de vos articles pour exécuter les commandes.",
				cta_title: "Prêt à moderniser votre gestion d’inventaire ?",
				cta_button: "Commencer gratuitement",
				cta_subtitle: "Aucune carte bancaire requise • Configuration en quelques minutes",
			},
			access_potential_customers: "Atteignez rapidement des clients potentiels",
			desc: "Conçu spécialement pour les exportateurs et les fabricants, Antrego accélère vos processus de vente et de marketing. Développez votre entreprise grâce à la gestion des stocks, au partage de stock client et à la gestion des expéditions !",
			global_market: "Prenez votre place sur le marché mondial avec la prise en charge de 15 langues différentes",
			main_title: "La solution de nouvelle génération pour les ventes et le marketing",
			manage_stocks: "Gérez et partagez vos stocks instantanément",
			speed_up_sales: "Accélérez les processus de vente",
			title: "Du Stock à la Vente",
		},
		$tracking: {
			$detailPage: {
				hero_title: "Suivi des expéditions en temps réel",
				hero_subtitle: "Surveillez chaque conteneur, à chaque étape",
				hero_description:
					"Le système de suivi avancé d’Antrego offre une visibilité complète sur vos expéditions avec des mises à jour en temps réel, des notifications automatisées et des rapports de statut détaillés. Ne perdez plus jamais la trace de vos conteneurs.",
				features_title: "Solution de suivi complète",
				feature_1_title: "Suivi des conteneurs en direct",
				feature_1_desc:
					"Suivez vos conteneurs en temps réel avec des localisations précises et des estimations d’arrivée pour chaque expédition.",
				feature_2_title: "Notifications automatisées",
				feature_2_desc:
					"Recevez des alertes instantanées pour les étapes clés : chargement, départ, arrivée, dédouanement et livraison.",
				feature_3_title: "Historique des statuts",
				feature_3_desc:
					"Accédez à l’historique complet des expéditions avec les journaux détaillés de tous les mouvements, changements de statut et événements clés.",
				feature_4_title: "Visibilité pour tous les acteurs",
				feature_4_desc:
					"Partagez les informations de suivi avec clients, fournisseurs et commissionnaires en douane. Tout le monde est informé automatiquement.",
				feature_5_title: "Gestion documentaire",
				feature_5_desc:
					"Joignez et accédez à tous les documents d’expédition, y compris connaissements, formulaires douaniers et certificats, en un seul endroit.",
				feature_6_title: "Alertes de retard",
				feature_6_desc:
					"Recevez des notifications proactives sur les retards potentiels pour intervenir avant que les problèmes ne s’aggravent.",
				benefits_title: "Pourquoi choisir le suivi Antrego ?",
				benefit_1: "Réduisez les demandes clients grâce à un accès en libre-service",
				benefit_2: "Prévenez les retards coûteux grâce à une surveillance proactive",
				benefit_3: "Améliorez la satisfaction client avec une communication transparente",
				benefit_4: "Gagnez du temps avec des mises à jour automatiques pour tous les acteurs",
				benefit_5: "Minimisez les risques grâce à une visibilité en temps réel sur le statut des expéditions",
				benefit_6: "Des pages de suivi professionnelles qui valorisent votre marque",
				workflow_title: "Comment fonctionne le suivi",
				step_1_title: "Créez l’expédition",
				step_1_desc:
					"Saisissez dans le système les détails d’expédition, numéros de conteneur, itinéraires et dates prévues.",
				step_2_title: "Mises à jour automatisées",
				step_2_desc:
					"Le système suit automatiquement les conteneurs et met à jour le statut à chaque point de contrôle.",
				step_3_title: "Notifications aux intervenants",
				step_3_desc:
					"Toutes les parties reçoivent des notifications instantanées lors des étapes importantes et changements de statut.",
				step_4_title: "Confirmation de livraison",
				step_4_desc:
					"Obtenez la confirmation finale de livraison avec la documentation complète et l’historique de l’expédition.",
				cta_title: "Commencez à suivre vos expéditions en toute confiance",
				cta_button: "Commencer gratuitement",
				cta_subtitle: "Aucune carte bancaire requise • Commencez le suivi dès aujourd’hui",
			},
			control_title: "Prenez le contrôle de vos expéditions avec Antrego.",
			real_time_alerts:
				"Alertes en temps réel : Recevez des notifications instantanées et des mises à jour complètes du statut de chaque conteneur.",
			secure_data_handling:
				"Gestion sécurisée des données : Téléchargez, partagez ou stockez facilement les données de vos expéditions directement sur la plateforme.",
			tracking_description:
				"La solution de suivi de conteneurs d’Antrego offre un moyen rapide et efficace de surveiller vos expéditions en temps réel. Gardez le contrôle et impressionnez vos partenaires avec des mises à jour détaillées et professionnelles.",
			tracking_title: "Suivez vos expéditions en toute simplicité !",
		},
		cancel_anytime: "Annulez à tout moment",
		customize_package:
			"Vous pouvez acheter un stockage supplémentaire et des utilisateurs et personnaliser votre forfait en fonction de vos besoins",
		free_features_1: "10 expéditions",
		free_features_2: "100 Mo de stockage",
		free_features_3: "Partenaires commerciaux illimités",
		free_features_4: "1 utilisateur",
		free_plan: "Gratuit",
		free_price: "0 $",
		free_regeneration: "",
		free_title: "Mensuel",
		premium_annual_features_1: "20 utilisateurs",
		premium_annual_features_2: "100 partenaires",
		premium_annual_features_3: "1000 expéditions",
		premium_annual_features_4: "1000 factures",
		premium_annual_price: "83,25 $",
		premium_annual_regeneration: "Renouvellement annuel à 999 $",
		premium_annual_title: "Annuel",
		premium_monthly_features_1: "Expéditions illimitées",
		premium_monthly_features_2: "Partenaires commerciaux illimités",
		premium_monthly_features_3: "2Go de stockage",
		premium_monthly_features_4: "3 utilisateurs",
		premium_monthly_price: "99 $",
		premium_monthly_regeneration: "Renouvellement mensuel à 99 $",
		premium_monthly_title: "Mensuel",
		premium_plan: "Forfait Premium",
		premium_plus_annual_features_1: "Expéditions illimitées",
		premium_plus_annual_features_2: "Partenaires commerciaux illimités",
		premium_plus_annual_features_3: "5Go de stockage",
		premium_plus_annual_features_4: "5 utilisateurs",
		premium_plus_annual_price: "83,25 $",
		premium_plus_annual_regeneration: "Renouvellement annuel à 999 $",
		premium_plus_annual_title: "Annuel",
		premium_plus_monthly_features_1: "Expéditions illimitées",
		premium_plus_monthly_features_2: "Partenaires commerciaux illimités",
		premium_plus_monthly_features_3: "5Go de stockage",
		premium_plus_monthly_features_4: "5 utilisateurs",
		premium_plus_monthly_price: "249 $",
		premium_plus_monthly_regeneration: "Renouvellement mensuel à 249 $",
		premium_plus_monthly_title: "Mensuel",
		premium_plus_plan: "Premium Plus",
		pricing_text: "Nous pouvons répondre à vos besoins de la meilleure façon sans dépasser votre budget.",
		pricing_title: "Antrego garantit de vous offrir le meilleur forfait et prix.",
		save_percentage: "Économisez 16 % par mois",
	},
	$language: {
		ar: "العربية",
		de: "Deutsch",
		en: "English",
		es: "Español",
		fr: "Français",
		hi: "हिन्दी",
		ind: "Bahasa Indonesia",
		it: "Italiano",
		ja: "日本語",
		ko: "한국어",
		pt: "Português",
		ru: "Русский",
		tr: "Türkçe",
		vi: "Tiếng Việt",
		zh: "中文",
	},
	$languageLocal: {
		ar: "Arabe",
		de: "Allemand",
		en: "Anglais",
		es: "Espagnol",
		fr: "Français",
		hi: "Hindi",
		ind: "Indonésien",
		it: "Italien",
		ja: "Japonais",
		ko: "Coréen",
		pt: "Portugais",
		ru: "Russe",
		tr: "Turc",
		vi: "Vietnamien",
		zh: "Chinois",
	},
	$message: {
		cannot_delete_verified_partner: "Vous ne pouvez pas supprimer un partenaire vérifié.",
		confirm: "Êtes-vous sûr de {function} ?",
		created: "{item} créé.",
		deleted: "{item} supprimé.",
		edited: "{item} modifié.",
		error_on_view_file: "Une erreur s'est produite lors de la visualisation du fichier.",
		file_oversize: "La taille du fichier doit être au maximum {size}.",
		invalid: "{item} invalide",
		migrated: "{item} migré. ({value})",
		process_has_been_started: "Votre {item} a été démarré.",
		saved: "{item} enregistré.",
		sent: "{item} envoyé.",
		sent_email: "E-mail envoyé. ({value})",
		sign_in_failed: "L'e-mail ou le mot de passe est incorrect",
		unsupported_file_type: "Type de fichier non pris en charge",
		updated: "{item} mis à jour.",
	},
	$pageDescriptions: {
		landing_page:
			"Antrego – Plateforme complète de gestion logistique pour exportateurs, importateurs et transitaires. Suivez les expéditions en temps réel, gérez les stocks, créez des factures et automatisez la documentation. Économisez 40 % de temps avec des solutions logistiques numériques. Essayez gratuitement !",
		stock_feature:
			"Transformez votre gestion des stocks avec Antrego. Gérez l’inventaire, créez des catalogues publics, suivez les lots entre entrepôts et convertissez instantanément le stock en expéditions. Parfait pour les exportateurs et fabricants.",
		tracking_feature:
			"Suivi en temps réel des conteneurs et expéditions avec Antrego. Surveillez chaque conteneur avec des mises à jour en direct, des notifications automatisées, un historique complet des statuts et une visibilité pour tous les acteurs. Ne perdez plus la trace de vos expéditions.",
		pdf_feature:
			"Créateur professionnel de documents PDF pour la logistique. Concevez des factures et proformas personnalisées avec un éditeur par glisser-déposer, des modèles et un remplissage automatisé des données. Créez des documents remarquables en minutes.",
		benefits_feature:
			"Découvrez les avantages d’Antrego. Tableau de bord centralisé, exactitude renforcée, gain de temps, collaboration d’équipe, réduction des coûts et évolutivité. Transformez dès aujourd’hui vos opérations logistiques.",
		contact:
			"Contactez Antrego – Posez vos questions, demandez une démo ou de l’assistance. Nous vous aidons à transformer vos opérations logistiques.",
		sign_in:
			"Connectez-vous à Antrego – Accédez à votre tableau de bord logistique pour gérer les expéditions, suivre les conteneurs, créer des factures et collaborer avec votre équipe. Portail de connexion sécurisé.",
		sign_up:
			"Inscrivez-vous à Antrego – Créez votre compte gratuit pour commencer à gérer vos opérations logistiques. Bénéficiez de 10 expéditions gratuites par mois. Aucune carte bancaire requise pour démarrer.",
	},
	$pageTitles: {
		accept_invitation: "Accepter l'invitation",
		benefits_feature: "Avantages de la plateforme – Solution logistique complète",
		company_profile: "Profil de l'entreprise",
		contact: "Contactez-nous – Entrer en relation avec Antrego",
		home: "Accueil",
		landing_page: "Gérez facilement tous vos processus d'expédition numériquement",
		partners: "Partenaires",
		pdf_editor: "Éditeur PDF",
		pdf_feature: "Créateur de documents PDF – Factures professionnelles",
		product_details: "Détails du Produit",
		product_groups: "Groupes de produits",
		products: "Produits",
		proforma_invoices: "Factures proforma",
		shipment_details: "Détails de l'expédition",
		shipments: "Expéditions",
		sign_in: "Connexion",
		sign_up: "Inscription",
		stock_details: "Détails du Stock",
		stock_feature: "Gestion des stocks – Transformez votre inventaire",
		stocks: "Stocks",
		subscription: "Abonnement",
		tracking_feature: "Suivi des expéditions – Contrôle en temps réel des conteneurs",
		user_profile: "Profil utilisateur",
	},
	$partnershipStatusTooltip: {
		createdHereDescription:
			"Partenaires non enregistrés, vous avez créé leur profil sur notre plateforme, vous pouvez donc afficher et modifier leurs informations.",
		createdHereTitle: "Créé ici :",
		description: "Vous pouvez suivre l'état de votre relation avec vos partenaires. Voici les différences :",
		verifiedPartnersDescription:
			"Ces partenaires ont accepté votre invitation et se sont inscrits sur la plateforme. Leurs informations sont en lecture seule et ne peuvent pas être modifiées.",
		verifiedPartnersTitle: "Partenaires vérifiés :",
	},
	$productGroup: {
		add_child: "Ajouter un enfant",
		add_new_product_group: "Ajouter un nouveau groupe de produits",
		add_to_root: "Ajouter à la racine",
		has_children_fail_message: "Un groupe de produits avec un enfant ne peut pas être supprimé",
		initial_message: "Utilisez ce bouton {0} pour créer votre premier groupe de produits.",
		name: "Nom",
		number_of_product: "Nombre de produits",
	},
	$proformaInvoice: {
		$actionDescription: {
			approve: "{name} approuvé.",
			create: "Créé par {name}.",
			create_attachment: "{name} a créé une pièce jointe.",
			delete_attachment: "{name} a supprimé une pièce jointe.",
			demand_revise: "{name} a demandé une révision.",
			mark_as_processed: "{name} marqué comme traité.",
			reject: "{name} rejeté.",
			revoke: "{name} révoqué.",
			send: "{name} envoyé au récepteur pour évaluation.",
			update: "Mis à jour par {name}.",
			update_attachment: "{name} a mis à jour une pièce jointe.",
		},
		$actions: {
			approve: "Approuver",
			demand_revise: "Demander une révision",
			mark_as_approved: "Approuvé",
			mark_as_processed: "Traité",
			mark_as_rejected: "Rejeté",
			mark_as_revise_demanded: "Révision demandée",
			mark_as_revoked: "Révoqué",
			mark_as_sent: "Envoyé",
			reject: "Rejeter",
			revoke: "Révoquer",
			send: "Envoyer",
		},
		$status: {
			approved: "Approuvé",
			pending_approval: "En attente d'approbation",
			pending_revise: "Révision en attente",
			processed: "Traité",
			rejected: "Rejeté",
			revoked: "Révoqué",
			template: "Modèle",
		},
		approve_confirm_message: "Êtes-vous sûr d'approuver la facture proforma ?",
		approve_success_message: "La facture proforma a été approuvée.",
		demand_revise_description_message: "Veuillez donner des détails sur vos attentes de révision :",
		demand_revise_success_message: "La facture proforma a été renvoyée à l'expéditeur pour révision.",
		mark_as_processed_confirm_message: "Confirmez-vous de marquer la facture proforma comme traitée ?",
		mark_as_processed_success_message: "La facture proforma a été marquée comme traitée.",
		no_attachment_text: "Aucune pièce jointe ajoutée pour le moment.",
		reject_confirm_message: "Êtes-vous sûr de rejeter la facture proforma ?",
		reject_success_message: "La facture proforma a été rejetée.",
		revoke_confirm_message: "Êtes-vous sûr de révoquer la facture proforma ?",
		revoke_success_message: "La facture proforma a été révoquée.",
		send_confirm_message: "Confirmez-vous l'envoi de la facture proforma au récepteur ?",
		send_success_message: "La facture proforma a été envoyée.",
	},
	$seoTitles: {
		landing_page: "Antrego | Logiciel de gestion logistique - Suivre, Gérer, Automatiser",
		stock_feature: "Logiciel de gestion des stocks | Système de suivi des stocks | Antrego",
		tracking_feature: "Logiciel de suivi des expéditions en temps réel | Suivi de conteneurs | Antrego",
		pdf_feature: "Générateur de facture proforma | Éditeur PDF pour la logistique | Antrego",
		benefits_feature: "Avantages d'une plateforme logistique complète | Solution tout-en-un | Antrego",
	},
	$serviceMessage: {
		already_subs_module: "Il existe déjà un abonnement pour ce module.",
		bad_request: "Mauvaise requête",
		code_already_used: "Le code a déjà été utilisé.",
		container_status_not_available: "Statut du conteneur non disponible.",
		existing_email_warning: "L'e-mail existe déjà.",
		existing_employee_error: "Cet utilisateur est déjà ajouté à votre entreprise.",
		existing_employee_for_email_warning: "Le code d'invitation a déjà été envoyé à cet e-mail",
		existing_invitation_warning: "Le code d'invitation a déjà été envoyé à cet e-mail.",
		existing_token_already_have_time: "Le jeton existant a déjà assez de temps pour être utilisé.",
		existing_user: "L'utilisateur existe déjà.",
		five_min_reset_password_mail:
			"Vous devez attendre au moins 5 minutes après avoir demandé un e-mail de réinitialisation du mot de passe.",
		forbidden: "Interdit",
		have_no_corporation: "Vous n'avez pas d'entreprise",
		have_no_custom_agency: "Vous n'avez pas d'agence douanière",
		have_no_employee: "Vous n'avez pas d'employé",
		instance_can_no_delete_existing_booking_code:
			"L'instance ne peut plus être supprimée en raison d'un code de réservation existant.",
		instance_cannot_delete: "L'instance ne peut plus être supprimée.",
		instance_not_found: "Instance non trouvée.",
		internal_server_error: "Erreur interne du serveur",
		invalid_current_password: "Mot de passe actuel invalide.",
		invalid_identifier_or_password: "Identifiant ou mot de passe invalide",
		invalid_invitation_code: "Le code d'invitation est incorrect.",
		invalid_moving_request: "Demande de déménagement invalide",
		invalid_operation: "Opération invalide",
		invalid_refresh_token: "Jeton de rafraîchissement invalide.",
		invalid_unit: "Unité invalide",
		invitation_accepting_is_due_to_the_admin: "L'acceptation de l'invitation est due à l'administrateur.",
		invitation_already_discarded: "L'invitation a déjà été annulée.",
		invitation_already_used: "L'invitation a déjà été utilisée.",
		invitation_has_been_used: "L'invitation a été utilisée.",
		invitation_not_exist_email: "L'invitation n'existe pas à cette adresse e-mail.",
		invitation_not_for_company: "Cette invitation n'est pas destinée à une entreprise.",
		invitation_not_for_custom_agency: "Cette invitation n'est pas destinée à une agence de douane.",
		invitation_not_found: "Invitation non trouvée.",
		invitation_not_valid: "L'invitation n'est plus valide.",
		link_has_been_expired: "Le lien a expiré.",
		link_not_be_used_anymore: "Ce lien ne peut plus être utilisé",
		missing_required_fields: "Champs obligatoires manquants.",
		no_employee_found: "Aucun employé trouvé",
		no_proper_partner_found: "Aucun partenaire approprié trouvé.",
		not_acceptable: "Non acceptable",
		not_allowed_action: "Vous n'êtes pas autorisé à effectuer cette action.",
		not_allowed_use_api: "Vous n'êtes pas autorisé à utiliser cette API.",
		not_found: "Non trouvé",
		not_have_purchase_subscription:
			"Votre plan d'abonnement a atteint la limite maximale pour les définitions. Pour en ajouter davantage, envisagez de passer à un abonnement supérieur.",
		not_permitted_use_api: "Vous n'êtes pas autorisé à utiliser cette API.",
		own_invitation_cannot_accept: "Vous ne pouvez pas accepter votre propre invitation.",
		parent_group_not_found: "Groupe parent non trouvé",
		partnerId_required: "L'ID partenaire est requis.",
		partnership_already_exists: "Le partenaire a déjà été ajouté.",
		password_cant_involve_space_char: "Le mot de passe ne peut pas contenir d'espace.",
		password_min_chars_least: "Le mot de passe doit contenir au moins 6 caractères.",
		payment_required: "Veuillez vous abonner pour ce processus.",
		paytr_integration_error: "Erreur d'intégration PayTR",
		ports_are_required: "Les ports sont requis.",
		product_group_tree_not_found: "Arborescence de groupe de produits non trouvée",
		proforma_invoice_action_not_available: "Le statut de la facture proforma n'est pas disponible pour cette action.",
		proforma_invoice_template_update: "La facture proforma doit être un modèle pour être mise à jour.",
		shipment_email_not_exist: "Veuillez entrer un e-mail valide.",
		shipment_method_is_required: "La méthode d'expédition est requise.",
		shipping_term_is_required: "La condition d'expédition est requise.",
		someone_else_uses_this_email: "Quelqu'un d'autre utilise cette adresse e-mail.",
		someone_else_uses_this_username: "Quelqu'un d'autre utilise ce nom d'utilisateur.",
		something_went_wrong: "Une erreur s'est produite",
		type_can_be_abstract_company: '"type" ne peut être que "entreprise_abstraite"',
		unauthorized: "Non autorisé",
		undefined_result: "Résultat indéfini",
		unexpected_error_occurred: "Une erreur inattendue est survenue",
		unit_already_added: "L'unité a déjà été ajoutée.",
		user_already_employee: "L'utilisateur est déjà un employé.",
		user_already_exists: "L'utilisateur existe déjà dans une entreprise.",
		user_does_not_exist: "L'utilisateur n'existe pas.",
		user_not_found: "Utilisateur non trouvé.",
		username_min_chars_error: '"Nom d\'utilisateur" doit comporter au moins 6 caractères.',
	},
	$shipment: {
		$actionDescription: {
			$land: {
				create_container: "{name} a ajouté un véhicule.",
				delete_container: "{name} a supprimé un véhicule.",
				update_container: "{name} a mis à jour un véhicule.",
			},
			create: "Créé par {name}.",
			create_attachment: "{name} a ajouté une pièce jointe.",
			create_container: "{name} a ajouté un conteneur.",
			delete_attachment: "{name} a supprimé une pièce jointe.",
			delete_container: "{name} a supprimé un conteneur.",
			update: "Mis à jour par {name}.",
			update_attachment: "{name} a mis à jour une pièce jointe.",
			update_container: "{name} a mis à jour un conteneur.",
		},
		$containerStatus: {
			arrived: "Arrivé",
			off_load: "Déchargé",
			on_load: "En charge",
			on_way: "En route",
			reserved: "Réservé",
		},
		$method: {
			aerial: "Aérien",
			land: "Terrestre",
			railway: "Ferroviaire",
			sea: "Maritime",
		},
		$vehicle: {
			license_number: "Plaque d'immatriculation",
		},
		archiving_success_message: "L'expédition a été archivée.",
		leave_message: "Laissez votre message ou commentaire",
		no_booking_info: "Aucune information de réservation n'a encore été définie. Utilisez le bouton {0} pour ajouter.",
		no_transportation_info: "Aucune information détaillée n'a encore été définie. Utilisez le bouton {0} pour définir.",
		un_archiving_success_message: "L'expédition a été désarchivée.",
	},
	$shortening: {
		number: "N°",
	},
	$socialMedia: {
		facebook: "Facebook",
		instagram: "Instagram",
		linked_in: "LinkedIn",
		twitter: "Twitter",
	},
	$subscription: {
		$message: {
			check_your_payment_method:
				"Votre abonnement n'a pas pu être renouvelé. Veuillez vérifier votre mode de paiement.",
			fail: "Une erreur inattendue est survenue. Veuillez réessayer plus tard. Si le problème persiste, veuillez le signaler en envoyant un e-mail à info@antrego.net.",
			ok: "Le processus d'achat a été initié. Le résultat du processus sera notifié par e-mail. Votre abonnement commencera lorsque le paiement sera terminé avec succès.",
			payment_process_is_ongoing:
				"Votre processus de paiement est en cours. Le résultat du processus sera notifié par e-mail. Votre abonnement commencera lorsque le paiement sera terminé avec succès.",
			success: "Votre abonnement a été créé avec succès. Vous pouvez commencer à utiliser Antrego facilement.",
			try_to_get_paid_again: "Votre abonnement a expiré. Cliquez ici pour le renouveler.",
			unsubscribed: "Désabonné",
			you_dont_have_any_subscription:
				"Vous n'avez pas d'abonnement. Veuillez choisir un forfait sur la page d'abonnement et commencez à l'utiliser facilement.",
			you_dont_have_any_subscription_text: "Veuillez choisir un plan pour continuer.",
			you_dont_have_any_subscription_title: "Vous n'avez aucun abonnement actif.",
		},
	},
	$unit: {
		acres: "Acres",
		boxes: "Boîtes",
		centimeter: "Centimètre",
		cubic_meter: "Mètre cube",
		dozen: "Douzaine",
		feet: "Pieds",
		fluid_ounces: "Onces liquides",
		gallons: "Gallons",
		gram: "Gramme",
		hectare: "Hectare",
		inches: "Pouces",
		kilogram: "Kilogramme",
		kilometer: "Kilomètre",
		liter: "Litre",
		meter: "Mètre",
		miles: "Miles",
		milligram: "Milligramme",
		milliliter: "Millilitre",
		millimeter: "Millimètre",
		ounces: "Onces",
		pallets: "Palettes",
		pieces: "Pièces",
		pounds: "Livres",
		quarts: "Quarts",
		square_feet: "Pieds carrés",
		square_inches: "Pouces carrés",
		square_kilometer: "Kilomètre carré",
		square_meter: "Mètre carré",
		square_miles: "Miles carrés",
		square_yards: "Yards carrés",
		ton: "Tonnes",
		yards: "Yards",
	},
	$validation: {
		email: "Veuillez entrer un e-mail valide",
		invalid: "{item} invalide",
		max_length: "{item} doit comporter moins de {length} caractères",
		min_length: "{item} doit comporter plus de {length} caractères",
		must_length: "{item} doit comporter {length} caractères",
		only_number: "{item} doit être un nombre",
		password_repeat_warning: "La répétition du mot de passe n'est pas identique au nouveau mot de passe.",
		required: "{item} est requis",
		required_for_default_language: "{item} est requis pour la langue par défaut de l'entreprise.",
		you_must_approve_distance_sales_agreement: "Vous devez approuver le contrat de vente à distance",
	},
	about: "À propos",
	accept_invitation: "Accepter l'invitation",
	accept_invitation_success_message: "Vous avez utilisé l'invitation avec succès.",
	accessibility: "Accessibilité",
	actions: "Actions",
	active: "Actif",
	activities: "Activités",
	add: "Ajouter",
	add_attribute: "Ajouter un Attribut",
	add_from_stock: "Ajouter depuis le stock",
	add_images: "Ajouter une Image",
	add_item: "Ajouter {item}",
	add_manually: "Créer ici",
	add_new_employee: "Ajouter un nouvel employé",
	add_new_packaging: "Ajouter un nouvel emballage",
	add_new_product: "Ajouter un nouveau produit",
	add_new_stock: "Ajouter un Nouveau Stock",
	add_new_warehouse: "Ajouter un Nouvel Entrepôt",
	add_stock_batch: "Ajouter un Lot de Stock",
	add_template: "Ajouter un modèle",
	add_variant: "Ajouter une Variante",
	address: "Adresse",
	again: "Encore",
	alert: "Alerte",
	already_have_employee_message: "Vous êtes déjà un employé d'une entreprise.",
	amount: "Montant",
	approve: "Approuver",
	archive: "Archiver",
	attachment: "Pièce jointe",
	attachments: "Pièces jointes",
	attribute: "Attribut",
	attributes: "Attributs",
	auto_attached_pdf: "PDF ajouté automatiquement",
	auto_detect: "Détection automatique",
	available: "Disponible",
	bank: "Banque",
	basket: "Panier",
	basket_empty: "Votre panier est vide",
	batch: "Lot",
	batch_no: "Numéro de Lot",
	batches: "Lots De Stock",
	benefits: "Avantages",
	billed_to: "Facturé à",
	booking: "Réservation",
	booking_code: "Code de réservation",
	booking_details: "Détails de la réservation",
	boolean: "Booléen",
	business_partner: "Partenaire commercial",
	business_partners: "Partenaires commerciaux",
	cancel: "Annuler",
	carrier: "Transporteur",
	change_password: "Changer le mot de passe",
	checking_invitation_code_message: "Vérification du code d'invitation",
	checkout: "Passer à la caisse",
	choose_image: "Choisissez une image",
	choose_your_plan: "Choisissez votre plan",
	clear: "Effacer",
	clear_basket: "Vider le panier",
	click_to_play_the_video: "Cliquez pour lire la vidéo",
	close: "Fermer",
	code: "Code",
	commercial: "Commercial",
	commercial_partner: "Partenaire commercial",
	commercial_partners: "Partenaires commerciaux",
	companies: "Entreprises",
	company: "Entreprise",
	company_address: "Adresse de l'entreprise",
	company_name: "Nom de l'entreprise",
	company_profile: "Profil de l'entreprise",
	configuration: "Configuration",
	confirm: "Confirmer",
	confirm_distance_selling_agreement: "Confirmez le contrat de vente à distance.",
	consult_us: "Consultez-nous",
	contact: "Contact",
	contact_info: "Informations de contact",
	contact_text: "Soyez assuré, nous vous contacterons dès que possible.",
	contact_title: "Consultez-nous, simplifiez vos processus",
	contact_to_us: "Contactez-nous",
	container: "Conteneur",
	container_no: "N° de conteneur",
	containers: "Conteneurs",
	content: "Contenu",
	contract: "Contrat",
	copy_link: "Copier le lien",
	corporation: "Entreprise",
	countries: "Pays",
	country: "Pays",
	create: "Créer",
	create_a_new_account: "Créer un nouveau compte",
	create_company: "Créer une entreprise",
	create_document: "Créer un document",
	create_shipment: "Créer une expédition",
	created_at: "Créé le",
	created_here: "Créé ici",
	credit_card_info: "Informations sur la carte de crédit",
	credit_card_no: "N° de carte de crédit",
	currencies: "Devises",
	currency: "Devise",
	current_password: "Mot de passe actuel",
	current_plan: "Plan actuel",
	customer_company_address: "Adresse de la société cliente",
	customer_company_name: "Nom de la société cliente",
	customs: "Douanes",
	customs_agencies: "Agences des douanes",
	customs_agency: "Agence des douanes",
	cvv: "CVV",
	daily: "Quotidien",
	damaged: "Endommagé",
	dashboard: "Tableau de bord",
	date: "Date",
	date_input: "Entrée de date",
	day: "Jour",
	default: "Défaut",
	default_language: "Langue par défaut",
	delete: "Supprimer",
	delete_account: "Supprimer le compte",
	delete_confirm_message: "Confirmez-vous la suppression ?",
	delete_document: "Supprimer le document",
	delete_template: "Supprimer le modèle",
	description: "Description",
	detail: "Détail",
	dimensions: "Dimensions",
	discard: "Annuler",
	discover_all_benefits: "Découvrir tous les avantages",
	distance_sales_agreement: "Le contrat de vente à distance",
	document: "Document",
	document_actions: "Actions sur les documents",
	document_added: "Document ajouté",
	document_creator: "Générateur de documents",
	document_manager: "Gestionnaire de documents",
	document_name: "Nom du document",
	document_number: "N° de document",
	document_overwrite: "Enregistrer les modifications comme nouveau document",
	document_save_info: "Ce document sera uniquement enregistré dans cette facture proforma.",
	document_updated: "Document mis à jour",
	download: "Télécharger",
	download_pdf: "Télécharger le PDF",
	download_template: "Télécharger le modèle",
	edit: "Modifier",
	edit_attribute: "Modifier l’attribut",
	edit_description: "Modifier la description",
	edit_document: "Modifier le document",
	edit_item: "Modifier {item}",
	edit_packaging: "Modifier l’emballage",
	edit_product: "Modifier le produit",
	edit_profile: "Modifier le profil",
	edit_stock: "Modifier le stock",
	edit_stock_batch: "Modifier le Lot de Stock",
	edit_template: "Modifier le modèle",
	edit_variant: "Modifier La Variante",
	edit_your_profile_picture: "Modifier votre photo de profil",
	email: "E-mail",
	employee: "Employé",
	employee_type: "Type d'employé",
	employees: "Employés",
	empty_data_warning:
		"Il n'y a pas encore de données dans ce domaine. Vous pouvez commencer à explorer la plateforme avec des données d'exemple.",
	estimated_arrival_day: "Jour d'arrivée estimé",
	expense: "Dépense",
	expenses: "Dépenses",
	expires_at: "Expire le",
	explore_pdf_editor: "Créez des documents instantanément",
	explore_stock_management: "Maîtrisez votre inventaire",
	explore_tracking_features: "Suivez en temps réel",
	exported_containers: "Conteneurs exportés",
	fail: "Échec",
	failed: "Échoué",
	faq: "FAQ",
	feedback: "Retour d'information",
	file: "Fichier",
	file_name: "Nom du fichier",
	file_preview: "Aperçu du fichier",
	file_processing_error_message: "Erreur lors du traitement du fichier : {error}",
	file_read_error_message: "Erreur de lecture du fichier",
	file_view: "Voir le fichier",
	filter: "Filtrer",
	first_name: "Prénom",
	first_name_last_name: "Prénom Nom",
	fixed_value: "Valeur fixe",
	forget_password: "Mot de passe oublié",
	forget_password_message: "Vous avez oublié votre mot de passe ?",
	forget_password_subtitle: "Veuillez entrer votre adresse e-mail pour réinitialiser votre mot de passe.",
	format: "Format",
	free: "Gratuit",
	from: "De",
	general: "Par défaut",
	get_started_now: "Commencez maintenant",
	give_us_feedback: "Donnez-nous votre avis",
	go_to_panel: "Accéder au panneau",
	go_to_proforma: "Aller à la proforma",
	go_to_shipment: "Aller à l'expédition",
	gross: "Brut",
	height: "Hauteur",
	hide: "Cacher",
	hide_all: "Tout masquer",
	home_page: "Page d'accueil",
	i_have_invitation_code: "J'ai un code d'invitation",
	image_delete: "Supprimer l'image",
	images: "Images",
	import_excel: "Importer depuis Excel",
	import_fail_message: "L'importation a échoué : {error}",
	import_success_message: "Importation réussie de {count} produits{skipped}.",
	imported_containers: "Conteneurs importés",
	in_progress: "En cours",
	in_stock: "En Stock",
	incoming: "Entrant",
	incoming_shipments: "Expéditions entrantes",
	initial: "Initial",
	inputs: "Contenu",
	invitation: "Invitation",
	invitation_code: "Code d'invitation",
	invitation_mail_sent: "E-mail d'invitation envoyé",
	invitations: "Invitations",
	invoice: "Facture",
	invoice_no: "Numéro de facture",
	join: "Rejoindre",
	join_company: "Rejoindre l'entreprise",
	language: "Langue",
	language_options: "Options de langue",
	last_name: "Nom de famille",
	last_one_year: "Dernière année",
	latitude: "Latitude",
	learn_more: "En savoir plus",
	left_a_comment: "A laissé un commentaire",
	length: "Longueur",
	link_copied: "Lien copié",
	link_copy_failed: "Échec de la copie du lien",
	loading_country: "Pays de chargement",
	loading_point: "Point de chargement",
	loading_port: "Port de chargement",
	log_in: "se connecter",
	logo: "Logo",
	longitude: "Longitude",
	lot_no: "Numéro de Lot",
	mail_sent: "E-mail envoyé",
	make_visible: "Rendre Visible",
	manage_profile: "Gérer le profil",
	mass: "Masse",
	measurements: "Mesures",
	merge_partner_description:
		"L'entreprise créée ici peut être fusionnée avec le partenaire vérifié existant lorsqu'elle crée un profil sur Antrego.",
	message: "Message",
	message_company_create: "Entreprise créée.",
	message_company_join: "Veuillez entrer le code d'invitation.",
	message_company_joined: "Vous avez rejoint l'entreprise",
	message_employee_delete: "Employé supprimé.",
	message_employee_save: "Employé enregistré.",
	message_join_company: "Entrez votre code pour rejoindre une entreprise existante",
	method: "Méthode",
	migrate: "Migrer",
	migrate_partner: "Migrer l'entreprise",
	migrate_partner_description:
		"L'entreprise créée ici peut être fusionnée avec le partenaire vérifié existant lorsqu'il crée un profil sur Antrego",
	missing_product_group_sheet_message: "Feuille Groupe de Produit manquante dans le fichier Excel",
	missing_product_sheet_message: "Feuille Produit manquante dans le fichier Excel",
	mobile_number: "Numéro de mobile",
	month: "Mois",
	month_lowercase: "mois",
	monthly: "Mensuel",
	multiple_select: "Sélection Multiple",
	my_profile: "mon profil",
	my_role: "Mon rôle",
	name: "Nom",
	net: "Net",
	new: "Nouveau",
	new_company_package: "gratuit",
	new_password: "Nouveau mot de passe",
	new_shipment: "Nouvel envoi",
	next: "Suivant",
	no: "Non",
	no_content: "Pas de contenu",
	no_entity: "Aucune entité",
	no_entity_message: "Aucune entité trouvée.",
	no_image: "Image non trouvée",
	no_product_data_message: "Aucune donnée de produit trouvée dans le fichier Excel",
	no_product_group_data_message: "Aucune donnée de groupe de produit trouvée dans le fichier Excel",
	no_stock_batches_found: "Aucun lot de stock trouvé",
	no_stock_matches_filters: "Aucun stock ne correspond aux filtres sélectionnés.",
	no_stocks_added_yet: "Aucun stock n’a encore été ajouté — veuillez en sélectionner ou en ajouter un.",
	no_text: "Pas de texte",
	no_valid_products_message:
		"Aucun produit valide trouvé. Tous les produits doivent avoir un nom dans la langue par défaut ({language}).",
	not_found_in_stock: "Aucun produit trouvé en stock avec les filtres actuels.",
	not_found_page_message: "Désolé, je n'ai pas pu trouver cette page :(",
	not_set: "Non défini",
	note: "Remarque",
	notes: "Notes",
	number_of_rows: "Nombre de lignes",
	ok: "OK",
	operation_fail: "Échec de l'opération",
	option: "Option",
	options: "Options",
	other: "Autre",
	out_of_stock: "En Rupture De Stock",
	outgoing: "Sortant",
	outgoing_shipments: "Expéditions sortantes",
	packages: "Forfaits",
	packaging: "Emballage",
	packing_list_title: "Liste de colisage",
	parent_group: "Groupe parent",
	partner: "Partenaire",
	partners: "Partenaires",
	partnership_status: "Statut du partenariat",
	passive: "Passif",
	password: "Mot de passe",
	pay: "Payer",
	payback: "Remboursement",
	payback_confirm_message: "Confirmez-vous le remboursement ?",
	payback_warning_message: "Si vous continuez, votre abonnement sera résilié.",
	payment: "Paiement",
	payment_amount: "Montant du paiement",
	payment_awaited: "Paiement attendu",
	payment_history: "Historique des paiements",
	payment_info: "Informations de paiement",
	payment_information: "Informations de paiement",
	payment_success: "Paiement réussi",
	payment_summary: "Résumé du paiement",
	payment_will_be_made_3d_secure: "*Votre paiement sera effectué avec 3D Secure.",
	pdf_attached_message: "PDF ajouté avec succès",
	pdf_editor: "Éditeur PDF",
	pdf_name: "Nom du PDF",
	pending_invitations: "Invitations en attente",
	per_month: "Par mois",
	phone_number: "Numéro de téléphone",
	pieces: "Pièces",
	plate_numbers: "Numéros de plaque",
	please_click_add_option: "Vous avez saisi une option mais ne l’avez pas ajoutée. Veuillez l’ajouter ou la supprimer.",
	prefix: "Préfixe",
	premium: "Premium",
	premium_plus: "Premium Plus",
	preview: "Aperçu",
	previous: "Précédent",
	price: "Prix",
	pricing: "Tarification",
	process: "Processus",
	product: "Produit",
	product_details: "Détails du Produit",
	product_group: "Groupe de produits",
	product_group_name: "Nom du groupe de produits",
	product_group_not_found_message: 'Groupe de produit "{group}" introuvable. Produit avec le code "{code}" ignoré.',
	product_groups: "Groupes de produits",
	product_images: "Images produit",
	product_name: "Nom du produit",
	products: "Produits",
	profile: "Profil",
	proforma_invoice: "Facture proforma",
	proforma_invoices: "Factures proforma",
	proforma_number: "N° de proforma",
	proforma_options: "Options Proforma",
	proforma_title: "Facture pro forma",
	purchase: "Achat",
	quantity: "Quantité",
	quantity_warning:
		"Puisque vous avez déjà modifié la valeur du Stock Total, le total ne sera pas calculé automatiquement.",
	ready_to_import: "Prêt à importer",
	receiver: "Récepteur",
	receiver_company: "Entreprise réceptrice",
	receiver_customs_agency: "Agence douanière réceptrice",
	redirection_to_home_link: "Accueil",
	redirection_to_home_message: "Vous pouvez également aller à ",
	redirection_to_sign_in_message: "Vous avez un compte ?",
	redirection_to_sign_up_message: "Vous n'avez pas encore de compte ?",
	reload: "Recharger",
	renewal: "Renouvellement",
	repaid: "Remboursé",
	reserved: "Réservé",
	reset_password: "Réinitialiser le mot de passe",
	returned: "Retourné",
	route: "Itinéraire",
	rows_per_page: "Lignes par page",
	sales: "Ventes",
	save: "Enregistrer",
	save_as_document: "Enregistrer comme document",
	save_as_new_document: "Enregistrer comme nouveau document",
	save_as_new_template: "Enregistrer comme nouveau modèle",
	save_as_template: "Enregistrer comme modèle",
	save_changes: "Enregistrer les modifications",
	save_pdf_to_attachments: "Enregistrer le PDF dans les pièces jointes",
	saved_card_info: "Informations sur la carte enregistrées",
	search: "Rechercher",
	select: "Sélectionner",
	select_a_file_to_preview: "Sélectionnez un fichier à prévisualiser",
	select_document: "Sélectionnez le document",
	select_document_to_overwrite: "Sélectionner le document à écraser",
	select_file: "Sélectionner un fichier",
	select_file_place_holder: "Veuillez sélectionner une image",
	select_language: "Sélectionner la langue",
	select_template: "Sélectionnez le modèle",
	select_template_to_overwrite: "Sélectionner le modèle à écraser",
	selected: "Sélectionné",
	selected_partner: "Partenaire sélectionné",
	send: "Envoyer",
	send_again: "Envoyer à nouveau",
	send_email: "Envoyer un e-mail",
	send_feedback: "Envoyer un avis",
	send_invitation: "Envoyer une invitation",
	sender: "Expéditeur",
	sender_company: "Entreprise expéditrice",
	sender_customs_agency: "Agence douanière expéditrice",
	separate_gross: "Ajouter des mesures brutes",
	settings: "Paramètres",
	shipment: "Expédition",
	shipment_code: "Code d'expédition",
	shipment_details: "Détails de l'expédition",
	shipment_method: "Méthode d'expédition",
	shipment_type: "Type d'expédition",
	shipments: "Expéditions",
	shipments_filter: "Filtre des expéditions",
	shipped: "Expédié",
	shipping_term: "Condition d'expédition",
	shipping_terms: "Conditions d'expédition",
	show: "Afficher",
	show_all: "Tout afficher",
	show_company_stock_page: "Afficher la Page de Stock de l'Entreprise",
	show_in_stocks: "Afficher sur la page de stock",
	sign_in: "Connexion",
	sign_out: "Déconnexion",
	sign_out_confirm_message: "Confirmez-vous la déconnexion ?",
	sign_out_success_message: "Au revoir.",
	sign_up: "Inscription",
	sizes: "Tailles",
	social_media: "Médias sociaux",
	social_media_account: "Compte sur les médias sociaux",
	start_time: "Heure de début",
	status: "Statut",
	stock: "Stock",
	stock_details: "Détails du Stock",
	stock_images: "Images de Stock",
	stock_status: "Statut Du Stock",
	stocks: "Stocks",
	stocks_url: "Lien de Stock",
	subscribe: "S'abonner",
	subscription: "Abonnement",
	subscription_info_message:
		"Vous pouvez bénéficier de tous les services de manière illimitée pendant la période d'abonnement.",
	subscription_warning_message:
		"**Vos informations de carte seront stockées en toute sécurité et votre abonnement sera renouvelé régulièrement sauf si vous l'annulez.",
	success: "Succès",
	super: "Super",
	supported_files_img: "Formats de fichier pris en charge : JPG, PNG.",
	switch_language: "Changer de langue",
	switch_theme: "Changer de thème",
	table_inputs: "Contenu du tableau",
	target: "Cible",
	target_partner: "Partenaire cible",
	tax_number: "Numéro fiscal",
	template: "Modèle",
	template_actions: "Actions sur les modèles",
	template_added: "Modèle ajouté",
	template_name: "Nom du modèle",
	template_overwrite: "Enregistrer les modifications comme nouveau modèle",
	template_save_info:
		"Les modèles enregistrés seront disponibles ultérieurement pour les factures proforma et les expéditions.",
	template_updated: "Modèle mis à jour",
	terms_of_sale_and_other_comments: "Conditions de vente - Commentaires",
	text_input: "Zone de texte",
	theme: "Thème",
	this_month: "Ce mois-ci",
	this_year: "Cette année",
	title: "Titre",
	to: "À",
	toDelete: "Supprimer",
	total: "Total",
	total_amount: "Montant total",
	total_price: "Prix Total",
	total_warning: "Si vous modifiez ces données, le total ne sera plus calculé automatiquement.",
	tracking: "Suivi des expéditions",
	transaction_no: "N° de transaction",
	transactions: "Transactions",
	try_for_free: "essayer gratuitement",
	type: "Type",
	types: "Types",
	un_archive: "Désarchiver",
	unit: "Unité",
	unit_price: "Prix unitaire",
	units: "Unités",
	unloading_country: "Pays de déchargement",
	unloading_point: "Point de déchargement",
	unloading_port: "Port de déchargement",
	unsubscribe: "Se désabonner",
	unsubscribe_confirm_message:
		"Si vous vous désabonnez, vous ne pourrez pas utiliser les fonctionnalités du système efficacement. Êtes-vous sûr de vouloir vous désabonner ?",
	upload_new_image: "Télécharger une nouvelle image",
	use_code: "Utiliser le code",
	use_invitation_code: "Utiliser le code d'invitation",
	use_invitation_code_description: "Saisissez votre code d'invitation envoyé dans votre boîte aux lettres.",
	use_invitation_code_success_message: "Le code d'invitation a été utilisé avec succès.",
	user_profile: "Mon Profil",
	value: "Valeur",
	variant: "Variante",
	variants: "Variantes",
	vehicle: "Véhicule",
	vehicles: "Véhicules",
	verified_partner: "Partenaire vérifié",
	verify_password: "Vérifier le mot de passe",
	visibility: "Visibilité",
	warehouse: "Entrepôt",
	warehouses: "Entrepôts",
	warn_unsaved_measurement: "N'oubliez pas de cliquer sur '+' pour ajouter vos mesures.",
	website: "Site web",
	week: "Semaine",
	weight: "Poids",
	weight_kg: "Poids (kg)",
	welcome: "Bienvenue",
	what_we_are_doing: "Ce que nous faisons",
	width: "Largeur",
	year: "Année",
	year_lowercase: "année",
	yearly: "Annuel",
	yes: "Oui",
	yes_no: "Oui / Non",
	you_dont_have_any_active_subscription: "Vous n'avez aucun abonnement actif.",
};
